import { Task } from "@common/types/task";
import { TaskDetailRow } from "./TaskDetailRow";
import { useTaskDependencySections } from "./useTaskDependencySections";

interface TaskDependencyRowsProps {
    task: Task;
}

/** The task's blockers, blocked tasks and related tasks as rows of the Details grid. */
export const TaskDependencyRows = ({ task }: TaskDependencyRowsProps) => {
    const sections = useTaskDependencySections(task);

    return (
        <>
            {sections.map(({ label, content }) => (
                <TaskDetailRow key={label} label={label}>
                    {content}
                </TaskDetailRow>
            ))}
        </>
    );
};
